import Vue from "vue";
import Router from "vue-router";
// import HelloWorld from "@/components/HelloWorld";
import homePage from "@/pages/home.vue";
import listPage from "@/pages/list.vue";
import * as utils from "@/utils";
import { URL_PATH } from "@/../config/config.js";

let trace = new utils.Trace("路由", true);

Vue.use(Router);

trace("OEM APP部署正式环境时的目录路径", URL_PATH);

export default new Router({
    // mode: "history",
    mode: "hash",
    base: process.env.NODE_ENV === "production" ? URL_PATH : undefined, //! 正式环境部署时要把这个加上
    routes: [
        // {
        //     path: "/",
        //     name: "HelloWorld",
        //     component: HelloWorld
        // },
        {
            path: "/",
            name: "homePage",
            component: homePage
        },
        {
            path: "/list",
            name: "listPage",
            component: listPage
        },
        {
            path: "/detail",
            name: "detailPage",
            component: homePage
        },
        {
            path: "*",
            redirect: "/"
        }
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js